/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Release, ReleaseStatus } from '../../../../ts/release';
import { RootState } from '../../../../ts/state';
import { entityAdapter } from './adapter';

const selectors = entityAdapter.getSelectors(
  (state: RootState) => state.releases
);

export const selectAllReleases = (state: RootState): Release[] =>
  state.releases ? selectors.selectAll(state) : [];

export const selectReleaseById = (
  state: RootState,
  id: string
): Release | undefined =>
  state.releases ? selectors.selectById(state, id) : undefined;

export const selectIsReleaseInProgress = (state: RootState): boolean =>
  Boolean(
    selectAllReleases(state)?.some(
      release => release.status === ReleaseStatus.PROCESSING
    )
  );
